import styled, { css } from 'styled-components';
import theme from 'src/utils/theme';
import _Text from '../../Text';

const LearnablesLabel = styled(_Text).attrs({
  $desktopStyles: css`
    font-size: ${theme.DEPRECATED_ty.medium};
    line-height: ${theme.DEPRECATED_ty.larger};
  `,
  $mobileStyles: css`
    font-weight: ${theme.DEPRECATED_ty.bold};
  `,
})(() => css``);

export default LearnablesLabel;
